import { render, staticRenderFns } from "./SigninForm.vue?vue&type=template&id=1f3fc270&"
import script from "./SigninForm.vue?vue&type=script&lang=js&"
export * from "./SigninForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports